import { useState, useEffect, useContext } from "react";
import styles from "./styles.module.css";
import { makeid } from "../utils/pageactions";
import ReactDOM from "react-dom";
import ClickAwayListener from "react-click-away-listener";
import { SourcesValue } from "../contexts/sources";
import { useMethods } from "../utils/methods";
import Modal from "../modal";
import { MdKeyboardBackspace, MdAdd } from "react-icons/md";

import * as Editors from "../editors";

export default function Standard({ value, onChange, params, sources }) {
  const [_value, setValue] = useState([]);
  const [focusInput, setFocusInput] = useState(-1);
  const [focusValue, setFocusValue] = useState("");

  useEffect(() => {
    console.log(value);
    if (Array.isArray(value) && value[0]) {
      setValue(value);
    } else if (params.type === "Text") {
      setValue([""]);
    } else if (params.type === "Number") {
      setValue([null]);
    } else {
      setValue([{}]);
    }
  }, [value]);

  const handleChange = (value, index) => {
    const newValue = [..._value];
    newValue[index] = value;
    setValue(newValue);
  };

  const handleInsertDynamic = (e) => {
    //e.preventDefault();
    const userSelection = window.getSelection().focusOffset;
    const text = focusValue;
    const before = text.substr(0, userSelection);
    const after = text.substr(userSelection, text.length);
    console.log(before, after, focusInput);
    const newValue = [..._value];
    newValue[focusInput] = before;
    newValue.splice(focusInput + 2, 0, after);
    newValue.splice(focusInput + 1, 0, {});
    console.log(newValue);
    const _newValue = [...newValue];
    setFocusValue(before);
    setValue(_newValue);
  };

  useEffect(() => {
    if (focusInput > -1) {
      setFocusValue(_value[focusInput]);
    } else {
      handleSave();
    }
  }, [focusInput]);

  const handleDivBlur = () => {
    handleChange(focusValue, focusInput);
    setFocusInput(-1);
  };

  const handleDelete = (i) => {
    const newValue = [..._value];
    if (i === 0) {
      newValue.splice(i, 1, {});
    } else {
      newValue.splice(i, 1);
    }
    const _newvalue = [];
    newValue.forEach((x, i, arr) => {
      if (typeof x === "string" && typeof arr[i + 1] === "string") {
        _newvalue.push(x + arr[i + 1]);
      } else if (typeof x === "string" && typeof arr[i - 1] === "string") {
      } else {
        _newvalue.push(x);
      }
    });
    setValue(_newvalue);
  };

  const handleSave = () => {
    onChange(_value);
  };

  return (
    <div className={styles.standardContainer}>
      {_value.map((v, i) => {
        if (typeof v === "string") {
          return (
            <span
              key={i}
              className={
                v.length < 1
                  ? `${styles.standardText} ${styles.empty}`
                  : styles.standardText
              }
              contentEditable
              onBlur={handleDivBlur}
              onFocus={(e) => {
                setFocusInput(i);
                console.log(e.target.innerText);
                setFocusValue(e.target.innerText);
              }}
              onInput={(e) => setFocusValue(e.target.innerText)}
              dangerouslySetInnerHTML={{ __html: v }}
            />
          );
        }
        if (typeof v === "object" && v !== null) {
          return (
            <DynamicPill
              value={v}
              type={params.type}
              list={params.list}
              extrasources={sources}
              onUpdate={(v) => handleChange(v, i)}
              onDelete={() => handleDelete(i)}
              key={i}
              onClose={handleSave}
            />
          );
        }
      })}
      {focusInput > -1 && (
        <MdAdd
          onClick={handleInsertDynamic}
          onMouseDown={(e) => e.preventDefault()}
          size={16}
          style={{ position: "absolute", top: -18, right: 0 }}
        />
      )}
    </div>
  );
}

const DynamicPill = ({
  value,
  onUpdate,
  onDelete,
  onClose,
  type,
  list,
  extrasources,
}) => {
  const [open, setOpen] = useState(null);
  const [source, setSource] = useState({ type: "", list: false });
  const [paramEdit, setParamEdit] = useState(null);
  const sources = useContext(SourcesValue);
  const methods = useMethods(source);
  useEffect(() => {
    if (Object.keys(value).length === 0) {
      return;
    }
    const recent = value[Object.keys(value).length - 1];

    let type = "";
    let list = false;
    if (recent.props[recent.returnType]) {
      type = recent.props[recent.returnType].type;
    } else {
      type = recent.returnType;
    }
    if (recent.props[recent.returnList]) {
      list = recent.props[recent.returnList].list;
    } else {
      list = recent.returnList;
    }
    setSource({ type, list });
  }, [value]);

  const handleOpen = (e) => {
    const width = window.innerWidth;
    const box = e.currentTarget.getBoundingClientRect();

    setOpen({ x: width - box.right, y: box.bottom + 4 });
  };

  const handleSelect = (s) => {
    const _value = { ...value };
    if (s.params.length === 0) {
      _value[Object.keys(_value).length] = {
        value: s.code,
        name: s.name,
        returnType: s.returnType,
        returnList: s.returnList,
        props: {},
        id: makeid(16),
        async: s.async,
      };
      onUpdate(_value);
    } else {
      setParamEdit(s);
    }
  };

  const handleBack = () => {
    const _value = { ...value };
    delete _value[Object.keys(_value).length - 1];
    onUpdate(_value);
  };

  const onParamSubmit = (source, index) => {
    const _value = { ...value };
    _value[Object.keys(_value).length] = source;
    onUpdate(_value);
    setParamEdit(null);
  };

  if (Object.keys(value).length === 0) {
    return (
      <>
        <div onClick={handleOpen} className={styles.pill}>
          <span>select...</span>
        </div>
        <Selector
          onSelect={handleSelect}
          value={value}
          options={[...sources, ...extrasources]}
          setOpen={setOpen}
          open={open}
          onDelete={onDelete}
          onClose={onClose}
          back={handleBack}
        />
        <ParamEdit
          submit={onParamSubmit}
          cancel={() => setParamEdit(null)}
          source={paramEdit}
        />
      </>
    );
  }
  return (
    <>
      <div
        onClick={handleOpen}
        className={
          type === source.type && list === source.list
            ? `${styles.pill} ${styles.valid}`
            : styles.pill
        }
      >
        {Object.keys(value).map((k) => {
          return (
            <>
              {k !== "0" && <span> - </span>}
              <span key={JSON.stringify(value[k])}>{value[k].name}</span>
            </>
          );
        })}
      </div>
      <Selector
        onClose={onClose}
        value={value}
        onSelect={handleSelect}
        options={methods}
        setOpen={setOpen}
        onDelete={onDelete}
        open={open}
        back={handleBack}
      />
      <ParamEdit
        submit={onParamSubmit}
        cancel={() => setParamEdit(null)}
        source={paramEdit}
      />
    </>
  );
};

const Selector = ({
  open,
  setOpen,
  value,
  options,
  onSelect,
  onClose,
  back,
  onDelete,
}) => {
  const handleClose = () => {
    onClose();
    setOpen(false);
  };
  if (!open) {
    return null;
  }
  return ReactDOM.createPortal(
    <ClickAwayListener onClickAway={handleClose}>
      <div style={{ right: open.x, top: open.y }} className={styles.selector}>
        {Object.keys(value).length > 0 ? (
          <div className={styles.selectorTitle}>
            <MdKeyboardBackspace
              className={"icon"}
              style={{ marginLeft: 2, marginTop: 6, padding: 6 }}
              onClick={back}
            />
            {Object.keys(value)
              .map((k) => value[k].name)
              .join(" - ")}
          </div>
        ) : (
          <div className={styles.selectorTitle}>Select</div>
        )}
        {options.map((s) => {
          return (
            <div
              key={s.name}
              onClick={() => onSelect(s)}
              className={styles.selectorOption}
            >
              {s.name}
            </div>
          );
        })}
        <div className={styles.deleteContainer}>
          <button onClick={onDelete} className={styles.delete}>
            Delete
          </button>
        </div>
      </div>
    </ClickAwayListener>,
    document.getElementById("menus")
  );
};

const ParamEdit = ({ source, cancel, submit }) => {
  const [props, setProps] = useState({});

  const handleSubmit = () => {
    const _source = {
      value: source.code,
      name: source.name,
      returnType: source.returnType,
      returnList: source.returnList,
      props: props,
      id: makeid(16),
      async: source.async,
    };
    submit(_source);
  };

  const handleParamChange = (value, param) => {
    const _props = { ...props };
    _props[param.name] = value;
    setProps(_props);
  };
  if (!source) {
    return null;
  }
  return (
    <Modal onClose={cancel} open={true}>
      <div className={styles.paramEditor}>
        <div
          style={{
            borderBottom: "1px solid var(--main-border-color)",
            padding: 15,
          }}
        >
          {source.name}
        </div>
        <div>
          {source.params.map((p) => (
            <Param
              onChange={(v) => handleParamChange(v, p)}
              param={p}
              key={p.name}
            />
          ))}
        </div>
        <button onClick={handleSubmit}>Submit</button>
      </div>
    </Modal>
  );
};

const Param = ({ param, onChange }) => {
  const Input = Editors[param.editor];

  if (!Input) {
    return null;
  }

  return (
    <div className={styles.paramContainer}>
      <div style={{ fontSize: 14, marginBottom: 6 }}>{param.displayName}</div>
      <Input onChange={onChange} />
    </div>
  );
};
